import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HTTP_INTERCEPTORS, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../loader/loader.service';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  readonly TOKEN_HEADER: string = 'Authorization';
  token: any;
  domainUrl: any;
  currentToast: any;
  constructor(
    private readonly router: Router,
    private readonly toaster: ToastrService,
    private readonly loaderservice: LoaderService,
    private readonly dialogRef: MatDialog) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('LoginForAdmin')) {
      this.domainUrl = localStorage.getItem("DomainUrl") != '' ? localStorage.getItem("DomainUrl") : window.location.host;
    } else {
      this.domainUrl = window.location.host;
    }
    let clickhere = localStorage.getItem('clickhere')
    if (clickhere == null || clickhere == 'false') {
      this.token = localStorage.getItem('AccessToken');
      if (this.token && !request.url.includes('ipinfo.io') && !request.url.includes('api64.ipify.org')) {
        request = request.clone({
          setHeaders: {
            Authorization: 'Bearer ' + this.token,
            RequestUrl: this.domainUrl
          },
        })
      }
      else if (!request.url.includes('api64.ipify.org')) {
        request = request.clone({
          headers: new HttpHeaders({ RequestUrl: this.domainUrl }),
        });
      }
    }

    return next.handle(request).pipe(
      tap({
        error: (err: any) => {
          if (err instanceof HttpErrorResponse && err.status === 401) {
            this.handleError401(err);
          }
        }
      })
    );

  }

  handleError401(error: HttpErrorResponse) {
    this.loaderservice.hide();
    this.dialogRef.closeAll();
    localStorage.clear();
    setTimeout(() => {
      this.router.navigate(['/login']);
      this.currentToast ??= this.toaster.error("Session expired!")
    }, 300);
  }
}

export const tokenInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: TokenInterceptor,
  multi: true
};





